import { useState } from "react";
import { initials, photoUrl } from "@/lib/api";

export const Avatar = ({ client, size = 46, radius = 10, fontSize, style, testId }) => {
  const [broken, setBroken] = useState(false);
  const url = photoUrl(client?.id, client?.photoKey);
  const base = { width: size, height: size, borderRadius: radius, flexShrink: 0, margin: 0, fontSize: fontSize || Math.round(size / 2.8), ...style };
  if (url && !broken) {
    return <img src={url} alt={client.name} className="avatar" style={{ ...base, objectFit: "cover", display: "block" }} data-testid={testId || `avatar-${client.id}`}
      onError={() => setBroken(true)} onLoad={(e) => { if (e.currentTarget.naturalWidth < 8) setBroken(true); }} />;
  }
  return <div className="avatar" style={base} data-testid={testId || `avatar-${client?.id}`}>{initials(client?.name)}</div>;
};
